import PropTypes from 'prop-types'
import { Navigate } from 'react-router-dom'
import { ID_PERFIL_ADMIN_EBP } from '../../constants/perfiles'
import { useAuth } from '../../hooks/useAuth'

const RUTA_REDIRECCION = '/Publicaciones'

const RutaProtegidaPorPerfil = ({ children, perfilesPermitidos }) => {
  const { loginDataContext: { idPerfil } = {} } = useAuth()
  const habilitado = idPerfil === ID_PERFIL_ADMIN_EBP || perfilesPermitidos.includes(idPerfil)

  if (!habilitado) {
    return <Navigate to={RUTA_REDIRECCION} replace />
  }

  return children
}

RutaProtegidaPorPerfil.propTypes = {
  children: PropTypes.node.isRequired,
  perfilesPermitidos: PropTypes.arrayOf(PropTypes.number).isRequired
}

export default RutaProtegidaPorPerfil
